export default "__VITE_ASSET__iEO2ISge__"